<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="wrap">
  <h1 class="text" data-testid="confirmation-component-title">{{ title | translate }}</h1>
  <div class="wrap-button">
    <div class="btn-no" (click)="redirect('cancel')" data-testid="confirmation-btn-no">
      <span class="CANCEL">{{ cancelButton | translate }}</span>
    </div>
    <div class="btn-yes" (click)="redirect('confirm')" data-testid="confirmation-btn-yes">
      <span class="CONFIRM">{{ confirmButton | translate }}</span>
    </div>
  </div>
  <div class="footer-screen-nav">
    <frodo-logo [src]="logo"></frodo-logo>
  </div>
</div>
